export const logError = error => {
  console.error("Error boundary catched error :", error);
};

export const isPageNotFound = error =>
  error && error.response && error.response.status >= 400 && error.response.status < 500;

export const isAccessDenied = error =>
  error && error.response && error.response.status === 403;
